<template>
  <section id="textile" class="c__section section__textile">
    <div class="c__container">
      <div class="c__headblock">
        <h2 class="c__leadcopy navy c__no__anm">
          あなたが求める<br />
          最高のパジャマ素材を
        </h2>
        <p class="navy c__bodycopy c__no__anm">
          BAKUNEには豊富な素材の種類があります。<br />
          好みや季節に合わせて選びましょう。
        </p>
      </div>
      <div class="textile__wrap">
        <FeaturesHowtochooseRecoverywearSleepitemPartsTextileItems
          v-for="textile in textileList"
          :key="textile.id"
          :textile="textile"
          :selected-textile-index="selectedTextileIndex[textile.id] ?? 0"
          @change="onChange(textile, $event)"
        />
        <div class="textile__item blank"></div>
        <div class="textile__item blank"></div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { TextileItem } from "~/utils/functions/howtochoose_recoverywear_sleepitem"

const selectedTextileIndex = ref<Record<string, number>>({})

// itemsが少ないとループの挙動がおかしくなるので倍の数にしている
const textileList: TextileItem[] = [
  {
    id: "textile_cool",
    name: "さらりとした素材",
    swiperClass: "coolTextile-swiper",
    items: [
      {
        name: "ドライ",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_dry.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img01.jpg",
        title: "吸汗速乾性で快適な着心地",
        description: "汗ばむ季節に、\nさらっと過ごしたい方におすすめ",
        fabric: "dry",
      },
      {
        name: "3D DRY",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_3d_dry.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img02.jpg",
        title: "BAKUNE Dryが進化した上位モデル",
        description: "サイドに縫い目がない3D構造で、\n快適な睡眠を追求したい方におすすめ",
        fabric: "3d-dry",
      },
      {
        name: "メッシュ",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_mesh.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img03.jpg",
        title: "軽やかで伸びがいい着心地",
        description: "BAKUNE最軽量、伸縮性バツグンで\nのびのび寝返りを打ちたい方におすすめ",
        fabric: "mesh",
      },
      {
        name: "ワッフル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_waffle.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img06.jpg",
        title: "凸凹のある素材で軽やかな肌あたり",
        description: "スタイリッシュなデザインで\nルームウエアとしてもおすすめ",
        fabric: "waffle",
      },
      {
        name: "ドライ",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_dry.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img01.jpg",
        title: "吸汗速乾性で快適な着心地",
        description: "汗ばむ季節に、\nさらっと過ごしたい方におすすめ",
        fabric: "dry",
      },
      {
        name: "3D DRY",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_3d_dry.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img02.jpg",
        title: "BAKUNE Dryが進化した上位モデル",
        description: "サイドに縫い目がない3D構造で、\n快適な睡眠を追求したい方におすすめ",
        fabric: "3d-dry",
      },
      {
        name: "メッシュ",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_mesh.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img03.jpg",
        title: "軽やかで伸びがいい着心地",
        description: "BAKUNE最軽量、伸縮性バツグンで\nのびのび寝返りを打ちたい方におすすめ",
        fabric: "mesh",
      },
      {
        name: "ワッフル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_waffle.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img06.jpg",
        title: "凸凹のある素材で軽やかな肌あたり",
        description: "スタイリッシュなデザインで\nルームウエアとしてもおすすめ",
        fabric: "waffle",
      },
    ],
  },
  {
    id: "textile_warm",
    name: "ふわりとした素材",
    swiperClass: "textile-swiper",
    items: [
      {
        name: "パイル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_pile.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img04.jpg",
        title: "汗を吸収しやすいタオル生地",
        description: "ふんわりやさしい触り心地で、\nルームウエアとしてもおすすめ",
        fabric: "pile",
      },
      {
        name: "スウェット",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_sweat.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img07.jpg",
        title: "使い勝手のよいスウェット生地",
        description: "しっとり加工でやわらかく、\n初めての方におすすめ",
        fabric: "sweat",
      },
      {
        name: "ウォーム",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_urakimou_sweat.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img08.jpg",
        title: "ふんわり暖かい肌あたり",
        description: "やわらかく暖かい裏起毛スウェットで\n真冬におすすめ",
        fabric: "lining-sweat",
      },
      {
        name: "パイル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_pile.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img04.jpg",
        title: "汗を吸収しやすいタオル生地",
        description: "ふんわりやさしい触り心地で、\nルームウエアとしてもおすすめ",
        fabric: "pile",
      },
      {
        name: "スウェット",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_sweat.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img07.jpg",
        title: "使い勝手のよいスウェット生地",
        description: "しっとり加工でやわらかく、\n初めての方におすすめ",
        fabric: "sweat",
      },
      {
        name: "ウォーム",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_urakimou_sweat.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img08.jpg",
        title: "ふんわり暖かい肌あたり",
        description: "やわらかいガーゼ素材でお肌へのやさしさを求める方におすすめ",
        fabric: "lining-sweat",
      },
    ],
  },
  {
    id: "textile_soft",
    name: "やさしい素材",
    swiperClass: "textile-swiper",
    items: [
      {
        name: "ガーゼ",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_gauze.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img05.jpg",
        title: "ガーゼ素材で\nワンランク上の肌触り",
        description: "やわらかいガーゼ素材でお肌へのやさしさを求める方におすすめ",
        fabric: "gauze",
      },
    ],
  },
  {
    id: "textile_premium",
    name: "プレミアムな素材",
    swiperClass: "textile-swiper",
    items: [
      {
        name: "サテン",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_satin.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img09.jpg",
        title: "上品な光沢感と、滑らかな肌あたり",
        description: "見た目にもこだわる方、\nギフトにもおすすめ",
        fabric: "satin",
      },
      {
        name: "ベロア",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_velor.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img10.jpg",
        title: "BAKUNEトップレベルの暖かさ",
        description: "もちっとした肌触り、\n保温性を重視する方におすすめ",
        fabric: "velor",
      },
      {
        name: "プレミアムパイル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_premium_pile.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img11.jpg",
        title: "シルクのような滑らかさ",
        description: "柔らかな国内製造で\nギフトにもおすすめ",
        fabric: "premium-pile",
      },
      {
        name: "サテン",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_satin.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img09.jpg",
        title: "上品な光沢感と、滑らかな肌あたり",
        description: "見た目にもこだわる方、\nギフトにもおすすめ",
        fabric: "satin",
      },
      {
        name: "ベロア",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_velor.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img10.jpg",
        title: "BAKUNEトップレベルの暖かさ",
        description: "もちっとした肌触り、\n保温性を重視する方におすすめ",
        fabric: "velor",
      },
      {
        name: "プレミアムパイル",
        image: "/images/site/feature/howtochoose_recoverywear_sleepitem/material_premium_pile.jpg",
        bakuneImage: "/images/site/feature/howtochoose_recoverywear_sleepitem/bakune_set_img11.jpg",
        title: "シルクのような滑らかさ",
        description: "柔らかな国内製造で\nギフトにもおすすめ",
        fabric: "premium-pile",
        url: "/products/bakune-pajamas-premium-pile",
      },
    ],
  },
]

const sessionKey = "howtochoose_recoverywear_sleepitem_textile"

const onChange = (textile: TextileItem, index: number) => {
  selectedTextileIndex.value[textile.id] = index

  // 選択した素材をセッションストレージに保存
  sessionStorage.setItem(sessionKey, JSON.stringify(selectedTextileIndex.value))
}

onMounted(() => {
  // 選択している素材をセッションストレージから取得
  if (sessionStorage.getItem(sessionKey)) {
    const savedSelectedColor = JSON.parse(sessionStorage.getItem(sessionKey) ?? "{}")
    selectedTextileIndex.value = savedSelectedColor
  }
})
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
